import { render, staticRenderFns } from "./TaxonomySearchResults.vue?vue&type=template&id=459661a1&"
import script from "./TaxonomySearchResults.vue?vue&type=script&lang=js&"
export * from "./TaxonomySearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports